@if (singleBetPick) {
    <div class="betslip-digital-bet-pick-column-0">
        @let pickChange = pickChange$ | async;
        @let showComboPrevention = showComboPrevention$ | async;
        @if (pickChange && removeButtonPosition === RemoveButtonPosition.Right) {
            <bs-digital-pick-selection
                [pick]="pickChange"
                [selection]="singleBetPick"
                [isLinear]="(isLinear$ | async) ?? false"
                [betslipType]="betslipType" />
        }
        @if (removeButtonPosition === RemoveButtonPosition.Left) {
            <bs-digital-pick-remove-button [removeButtonStyle]="removeButtonStyle" (remove)="removePick()" />
        }
        @if (pickChange && showComboPrevention) {
            <bs-digital-combo-prevention-indicator [isLinearGlobalIndicator]="true" [pick]="pickChange" />
        }
    </div>
    <bs-digital-single-bet-pick-info-column
        [pick]="pick"
        [pickClass]="pickClass"
        [singleBetPick]="singleBetPick"
        [oddsDisplayFormat]="oddsDisplayFormat"
        [isMultiSingleBet]="isMultiSingleBet"
        [alwaysShowStakeInput]="alwaysShowStakeInput"
        [messages]="messages"
        [pickChange$]="pickChange$"
        [pickTemplate]="pickTemplate"
        [isLinear]="isLinear"
        (clickInfo)="eventClick()" />
    <div class="betslip-digital-bet-pick-column-2">
        @if (removeButtonPosition === RemoveButtonPosition.Right) {
            <bs-digital-pick-remove-button [removeButtonStyle]="removeButtonStyle" (remove)="removePick()" />
        }
    </div>
    <bs-single-pick-errors class="single-bet-pick__errors-container" [pickId]="pick.id" />
    <bs-digital-single-bet-pick-stake-keyboard [pickId]="pick.id" />
}
